import React,{useEffect} from 'react';
import { useDispatch , useSelector } from 'react-redux';
import { Alert, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
// import Product from '../components/Product'
import { listProducts } from '../actions/productActions';
import Message from '../components/Message';
import Loader from '../components/Loader';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';


import DataTable from 'react-data-table-component';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  }

}));

const PenerimaanScreen = () => {
  
const columns = [
  {
    name: 'Name',
    selector: 'name',
    sortable: true,
  },
  {
    name: 'Harga',
    selector: 'price',
    sortable: true,
    right: true,
  },
  {
    name: 'Text',
    selector: 'content',
    sortable: true,
    right: true,
  },
  {
    name: 'Gambar',
    cell: row => <div data-tag="allowRowEvents"><div ><img src={"/images/"+row.pic[0].nama} alt={row.name}></img></div>{row.name}</div>,
    sortable: true,
  },
];

    const classes = useStyles()
    const dispatch = useDispatch()

    const productList = useSelector((state) => state.productList)
    const { loading, error, products} = productList
    // console.log(products)

    useEffect(() => {
      dispatch(listProducts())
    }, [dispatch])
    return (
        <>
      <h1>Penerimaan</h1>
        {loading ? (
      <Loader />
      ) : error ? (
        console.log({error})
        // <Message variant='danger'>{error}</Message>
      ) : (

    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        '& > :not(style)': {
          m: 1,
          width: 128,
          height: 128,
        },
      }}
    >
      <Paper elevation={0} />
      <Paper />
      <Paper elevation={3} />
    </Box>
     )} 
        </>
    )
}

export default PenerimaanScreen
